import React from 'react';
import { useTranslation } from 'react-i18next';
import { RoadMaintenance } from '../../../../../../../services/types/Calculator';
import NumberFormatterSinSeparador from '../../../NumberFormatterSinSeparador';

interface Props {
  roadMaintenance: RoadMaintenance;
  defaultArea: number | null;
}

const RoadMaintenanceDetails: React.FC<Props> = ({ roadMaintenance, defaultArea }) => {
  const { t } = useTranslation();

  return (
    <div className="content-calculator" style={{ overflow: 'hidden' }}>
      <div className="row calculator-input-row">
        <div className="col-12 col-sm-5 col-md-3 col-lg-5">
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Default Road Area to be Maintained (sq meters)')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-4">
          <input
            type="text"
            id="defaultarearoadInput"
            value={(<NumberFormatterSinSeparador value={defaultArea} />).props.value}
            className="details-input"
            disabled
            title=""
          />
        </div>
      </div>
      <div className="row calculator-input-row">
        <div className="col-12 col-sm-5 col-md-3 col-lg-5">
          <label className="col-form-label mr-2" htmlFor="sector">
            {t('Custom Road Area to be Maintained (sq meters)')}
          </label>
        </div>
        <div className="col-12 col-sm-5 col-md-4 col-lg-4">
          <input
            type="text"
            id="customroadInput"
            value={(<NumberFormatterSinSeparador value={roadMaintenance.area} />).props.value}
            className="details-input"
            disabled
            title=""
          />
        </div>
      </div>
    </div>
  );
};

export default RoadMaintenanceDetails;
